const initialState = {
    accessToken: false,
    refreshToken: false
};
const reduxState = (state = initialState, { type, ...rest }) => {
    switch (type) {
        case 'set':
            return { ...state, ...rest };
        default:
            return state;
    }
};
export default reduxState;
